import request from '@/utils/request'
import api from '../api'

export class BankRecord {
  search(data) {
    return request({
      url: api.bankRecord.search,
      method: 'post',
      data
    })
  }
  selfSearch(data) {
    return request({
      url: api.bankRecord.selfSearch,
      method: 'post',
      data
    })
  }
  downloadTemplate(data) {
    return request({
      url: api.bankRecord.downloadTemplate,
      method: 'post',
      data
    })
  }
  uploadReportMaterial(data) {
    return request({
      url: api.bankRecord.uploadReportMaterial,
      method: 'post',
      data
    })
  }
  downloadReport(params) {
    return request({
      url: api.bankRecord.downloadReport,
      method: 'get',
      params
    })
  }
  saveReport(params) {
    return request({
      url: api.bankRecord.saveReport,
      method: 'put',
      params
    })
  }
}
